import { render, staticRenderFns } from "./breastpiece_bind_list.vue?vue&type=template&id=2d8ef66e&scoped=true"
import script from "./breastpiece_bind_list.vue?vue&type=script&lang=js"
export * from "./breastpiece_bind_list.vue?vue&type=script&lang=js"
import style0 from "./breastpiece_bind_list.vue?vue&type=style&index=0&id=2d8ef66e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ef66e",
  null
  
)

export default component.exports